import type { ElasticSearchOptions } from '@comfama/frontend-utils';

/**
 * Configuración central del buscador universal de la Agenda. Portar la feature
 * a otro sitio debería requerir editar solo este archivo.
 *
 * Los valores que dependen de variables de entorno usan getters para leerse de
 * forma perezosa: respetan el `process.env` vigente en runtime y en tests.
 */
export const searchConfig = {
  elastic: {
    /** URL base del clúster (variable de entorno). */
    get baseUrl(): string {
      return process.env.GATSBY_ELASTICSEARCH_URL ?? '';
    },
    apiKey: '',
    /** Sintaxis de Elasticsearch: `*` = todos, `-foo` = excluir `foo`. */
    indexQuery: '*,-cda_contentful_projects_ai',
    /** Índices que se priorizan en los resultados. */
    boostIndex: ['agenda_eventtia_logstash'],
    /** Campos que se solicitan en cada documento. */
    selectedFields: [
      'id',
      'origin',
      'category',
      'title',
      'description',
      'tags',
      'centrosCulturales',
      'municipality'
    ]
  },

  topContent: {
    /** Documento de top content relativo a `elastic.baseUrl`. */
    docPath: 'search_top_content/_doc/top_content_agenda',
    get apiKey(): string {
      return process.env.GATSBY_ELASTICSEARCH_TOP_CONTENT_API_KEY ?? '';
    }
  },

  /** Página de resultados a la que navega la búsqueda completa. */
  resultsRoute: '/eventos/',

  /** Búsquedas recientes guardadas en `localStorage`. */
  recentSearches: {
    storageKey: 'recent_searches',
    maxItems: 2,
    icon: 'icon-Search'
  },

  /** Cantidad de tarjetas de "Lo más buscado" / "Contenido para ti" en móvil. */
  mobileContentLimit: 3
};

/** Opciones listas para `useElasticSearch`, derivadas de `searchConfig`. */
export const getElasticOptions = (): ElasticSearchOptions => ({
  apikeyElastic: searchConfig.elastic.apiKey,
  urlElastic: `${searchConfig.elastic.baseUrl}/_search?index=${searchConfig.elastic.indexQuery}`,
  selectedFields: searchConfig.elastic.selectedFields,
  boostIndex: searchConfig.elastic.boostIndex
});
